<template>
	<div ref="bundleWidget" class="bundle-widget-outer-wrapper">
		<PopOver
			:open="isPopOpen"
			:placement="isBottomOpen ? 'bottom-start' : 'right-start'"
			@overlay-click="closePopover()"
		>
			<div class="bundle-widget-wrapper" :tabindex="tabindex" @click="handleClick($event)">
				<!---Header-->
				<div class="bundle-widget-header">
					<div class="display-flex j-c-space-bet">
						<div>
							<p class="title">
								{{ name }}

								<Icon
									name="genric"
									:effects="false"
									type="filled"
									state="primary"
									size="18px"
									class="margin-lt-8"
								/>
							</p>
							<InfoPopover
								placement="bottom-start"
								max-width="340"
								container=".bundle-widget-container"
							>
								<!--Trigger Data-->
								<p class="paragraph-2 fc-light margin-tp-4 last-updated-text">
									{{ lastUpdated.label }}
								</p>
								<!--Trigger Data-->

								<!--Body Data-->
								<template #body>
									<p>{{ lastUpdated.info }}</p>
								</template>
								<!--Body Data-->
							</InfoPopover>
						</div>

						<div>
							<div class="display-flex j-c-end fs-12 bw-dev-services-wrapper">
								<Icon
									v-for="(service, si) in services"
									:key="service.name"
									:name="service"
									type="filled"
									size="18px"
									:class="services.length > si + 1 ? 'margin-rt-12' : ''"
								/>
							</div>

							<div
								class="display-flex j-c-end align-items-center margin-tp-8 bundle-version-list-wrap"
							>
								<!--Pophover element data-->
								<VPopover
									placement="bottom-end"
									container="div.bundle-widget-container"
									popover-class="element bundle-w-pop-version"
								>
									<p class="paragraph-2 cursor-pointer version-icon">
										Version: {{ versions.selected
										}}<Icon
											name="i-triangle-down"
											class="margin-lt-4"
											size="xx-small"
											type="filled"
											state="font-light"
											:effects="false"
										/>
									</p>

									<template v-slot:popover>
										<p
											v-for="(vari, index) in versions.options"
											:key="vari.name"
											v-close-popover
											class="fc-dark display-flex j-c-space-bet align-items-center cursor-pointer"
											:class="versions.options.length > index + 1 ? 'margin-bt-8' : ''"
											@click="selectVersion(vari.name, index)"
										>
											<span class="paragraph-2">{{ vari.name }}</span>
											<span v-if="vari.selected" class="display-flex align-items-center">
												<Icon
													name="i-tick"
													class="margin-lt-8"
													size="x-small"
													type="filled"
													state="dark"
													:effects="false"
												/>
											</span>
										</p>
									</template>
								</VPopover>
								<!-- Pophover element data-->
							</div>

							<div
								class="display-flex j-c-end align-items-center fs-12 margin-tp-8 bw-stats-wrapper"
							>
								<p
									v-for="(information, index) in stats"
									:key="information.id"
									class="paragraph-2 display-flex align-items-center"
								>
									<Icon
										:name="information.icon"
										state="font-light"
										:effects="false"
										size="x-small"
										type="filled"
									/>
									<span class="margin-lt-4">{{ information.data }}</span>
									<span v-if="stats.length > index + 1" class="margin-lt-8 margin-rt-8 fc-light">
										|
									</span>
								</p>
							</div>
						</div>
					</div>
				</div>
				<!---Header-->
				<!---Body-->
				<div v-if="$slots['default']" class="bundle-widget-body">
					<!-- @slot Used for Stats Data For Body-->
					<slot />
				</div>
				<!---Body-->
				<!---Footer-->
				<div class="bundle-widget-footer">
					<div
						class="bundle-widget-project-trigger"
						:class="hoverEffect.left ? '' : 'disabled'"
						@click="openProjectList(hoverEffect.left)"
					>
						<div>
							<span class="inst-text">Intall to </span>
							<p class="name-text">
								{{ currectProject }}
							</p>
						</div>
						<div>
							<Icon
								name="i-setting"
								size="x-small"
								type="filled"
								state="dark"
								@click.stop="projectSetting(currectProject)"
							/>
							<Icon
								:class="isBottomOpen ? 'transtion-icon' : ''"
								name="i-triangle-down"
								size="x-small"
								state="dark"
								class="margin-lt-8"
								type="filled"
								:effects="false"
							/>
						</div>
					</div>
					<div
						class="install-trigger"
						:class="hoverEffect.right ? '' : 'disabled'"
						@click="openInstallList(hoverEffect.right)"
					>
						<span> Install </span>
					</div>
				</div>
				<!---Footer-->
			</div>
			<!-- </div> -->

			<template #content>
				<!--Bundle Install wrapper  Data-->
				<div
					v-if="!isBottomOpen && installOpen"
					class="bundle-widget-install-wrapper"
					:style="{ maxWidth: widthH + 'px', minWidth: widthH + 'px' }"
				>
					<div class="bundle-install-header">
						<span class="display-flex align-items-center">
							<Icon :name="icon" :effects="false" type="filled" size="small" class="margin-rt-4" />
							<h4 class="intall-wrap-title margin-lt-4">{{ currectProject }}</h4>
						</span>

						<span class="display-flex align-items-center">
							<Icon
								name="i-setting"
								type="filled"
								state="dark"
								size="small"
								class=""
								@click="installSetting(currectProject)"
							/>
							<Icon
								name="i-close"
								type="filled"
								state="dark"
								size="small"
								class="margin-lt-16"
								@click="closePopover()"
							/>
						</span>
					</div>
					<!--@slot Used for Install Data -->
					<slot name="install" />
				</div>
				<!--Bundle Install wrapper  Data-->

				<!--Bundle Project list  Data-->
				<div
					v-if="isBottomOpen"
					class="bundle-widget-project-list"
					:style="{ maxWidth: widthH + 'px', minWidth: widthH + 'px' }"
				>
					<div>
						<Slab type="bottom-border" state="default" state-type="solid">
							<p class="paragraph-2">Available Projects</p>
						</Slab>

						<Slab
							v-for="(project, index) in projectList"
							:key="project.vid"
							:type="projectList.length > index + 1 ? 'bottom-border' : 'transparent'"
							size="medium"
							state="default"
							state-type="solid"
							class="cursor-pointer"
							@click="projectSelected(project.name, index, project.iconName)"
						>
							<template #primary-action>
								<Icon
									:name="project.iconName || 'i-genric'"
									:effects="false"
									type="filled"
									size="small"
									class=""
								/>
							</template>
							<p>
								{{ project.name }}
								<span v-if="project.default" class="fc-light">(default project)</span>
							</p>

							<template #secondary-actions>
								<div class="display-flex align-items-center j-c-end">
									<Icon
										name="i-setting"
										class="margin-rt-12"
										size="small"
										type="filled"
										state="dark"
										:effects="true"
										@click.stop="projectSetting(project.name)"
									/>
									<RadioButton :checked="project.checked" />
								</div>
							</template>
						</Slab>
					</div>
				</div>
				<!--Bundle Project list  Data-->
			</template>
		</PopOver>
	</div>
</template>
<script>
import { defineComponent } from "vue";
import Icon from "./../Icon/Icon";
import RadioButton from "./../FormElements/RadioButton";
import InfoPopover from "./../InfoPopover/InfoPopover";
import Slab from "./../Slab/Slab";
import { VPopover, VClosePopover } from "v-tooltip";
import PopOver from "./../PopOver/PopOver";

export default defineComponent({
	name: "BundleWidget",
	components: {
		Icon,
		InfoPopover,
		RadioButton,
		Slab,
		VPopover,
		PopOver
	},
	directives: {
		VClosePopover
	},
	props: {
		/**
		 * tabindex number
		 *  */
		tabindex: {
			type: Number,
			default: -1
		},
		/**
		 * Accept list of array to show ProjectList at the bottom
		 *  */
		projectList: {
			type: Array,
			default() {
				return [];
			}
		},
		/**
		 * Use to show card title name
		 *  */
		name: {
			type: String,
			default: ""
		},
		/**
		 * List of services to show on the top
		 * 'aws'| 'gcp'
		 * */
		services: {
			type: Array,
			default() {
				return [];
			}
		},
		/**
		 * List of stats to  show on the top
		 * 'deloy'| 'like' | 'comment'
		 *  */
		stats: {
			type: Array,
			default() {
				return [];
			}
		},
		/**
		 * Last updated pophover
		 * 'label'| 'info'
		 *  */
		lastUpdated: {
			type: Object,
			default() {
				return {
					label: "",
					info: ""
				};
			}
		},
		/**
		 * Show list of versions
		 * 'selected'| 'options'
		 *  */
		versions: {
			type: Object,
			default() {
				return {};
			}
		},
		/**
		 * To Disable Hover effect and add disbale effect or vice versa
		 * 'right'| 'left'
		 *  */
		hoverEffect: {
			type: Object,
			default() {
				return {
					left: true,
					right: true
				};
			}
		}
	},
	data() {
		return {
			isPopOpen: false,
			widthH: 0,
			isBottomOpen: false,
			installOpen: false,
			icon: this.projectList[0] ? this.projectList[0].iconName : "test",
			currectProject: this.projectList[0] ? this.projectList[0].name : "test"
		};
	},
	methods: {
		handleClick(e) {
			/**
			 * Event Triggered when you click widget
			 *
			 * @event click
			 */
			this.$emit("click", e);
		},
		calculateWidth() {
			this.widthH = this.$refs.bundleWidget.clientWidth;
			// console.log(this.widthH);
		},
		openProjectList(exe) {
			if (exe) {
				// console.log(exe);
				this.isBottomOpen = !this.isBottomOpen;
				if (this.isBottomOpen) {
					this.isPopOpen = true;
				}

				this.installOpen = false;
				if (!this.isBottomOpen) {
					this.closePopover();
				}
				this.calculateWidth();
			}
		},
		openInstallList(exe) {
			if (exe) {
				// console.log(exe);
				this.isBottomOpen = false;
				this.installOpen = !this.installOpen;
				if (this.installOpen) {
					this.isPopOpen = true;
				}

				if (!this.installOpen) {
					this.closePopover();
				}
				this.calculateWidth();
				/**
				 * Event Triggered when you click on intall button
				 *
				 * @event open-install
				 */
				this.$emit("open-install");
			}
		},

		closePopover() {
			this.isPopOpen = false;
			this.installOpen = false;
			this.isBottomOpen = false;
		},

		projectSelected(name, index, icon) {
			// console.log(name + index);
			const projectInfo = {
				name,
				index
			};
			this.currectProject = name;
			this.icon = icon;

			this.projectList.forEach((data, i) => {
				if (i === index) {
					data.checked = true;
				} else {
					data.checked = false;
				}
			});
			this.isBottomOpen = false;
			this.isPopOpen = false;

			/**
			 * Event Triggered when you select any project from list
			 *
			 * @event select-project
			 */
			this.$emit("select-project", projectInfo);
		},
		projectSetting(name) {
			// console.log(name);
			const _name = name;

			/**
			 * Event Triggered when you click on setting icon of  any project from list
			 *
			 * @event project-settings
			 */
			this.$emit("project-settings", _name);
		},
		installSetting(name) {
			// console.log(name);
			const _name = name;
			/**
			 * Event Triggered when you click on setting icon of install box header
			 *
			 * @event install-settings
			 */
			this.$emit("install-settings", _name);
		},
		selectVersion(version, index) {
			// console.log(this.versions.options);
			// eslint-disable-next-line vue/no-mutating-props
			this.versions.selected = version;
			this.versions.options.forEach((data, i) => {
				if (i === index) {
					data.selected = true;
				} else {
					data.selected = false;
				}
			});
			/**
			 * Event Triggered when you select any version from list
			 *
			 * @event select-version
			 */
			this.$emit("select-vesion", version);
		}
	}
});
</script>
<style lang="scss">
.bundle-widget-container {
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(410px, 1fr));
	grid-gap: 8px;
	.bundle-w-pop-version {
		.tooltip-inner.popover-inner {
			padding: 8px;
		}
	}
}

.bundle-widget-wrapper {
	position: relative;
	width: 100%;
	min-width: 410px;

	display: flex;
	flex-direction: column;
	background-color: var(--dashboard-element-light);
	border-radius: 4px;

	> div.bundle-widget-header {
		padding: 16px;
		display: flex;
		justify-content: space-between;
		flex-direction: column;
		color: var(--dashboard-font-light);
		.title {
			color: var(--dashboard-font-dark);
			font-size: 16px;
			line-height: 24px;
			font-weight: 500;
			max-width: 240px;
			padding-right: 20px;
			.icon-container {
				position: absolute;
				margin-top: 2px;
			}
		}
		.bundle-version-list-wrap {
			.open {
				.version-icon {
					.icon-container {
						transform: rotate(180deg) !important;
						transition: all 0.3s linear;
					}
				}
			}
		}
	}
	> div.bundle-widget-body {
		padding: 16px;
		min-height: 91px;
		border-top: 1px solid var(--dashboard-border);
		display: flex;
		justify-content: space-between;
		flex-direction: column;
		color: var(--dashboard-font-light);
		.service-list {
			max-width: 200px;
			width: 100%;
		}

		.bundle-widget-service-icon-list {
			display: flex;
			align-items: center;
			> * {
				margin-right: 4px;
				.trigger {
					line-height: 0px;
				}
				&:last-child {
					margin-right: 0px;
				}
			}
		}
	}
	> div.bundle-widget-footer {
		padding: 0px;
		min-height: 40px;
		display: flex;
		align-items: center;
		justify-content: space-between;

		.bundle-widget-project-trigger {
			border-radius: 0px 0px 0px 4px;
			padding: 8px 16px;
			width: calc(100% - 90px);
			background-color: var(--dashboard-element);
			color: var(--dashboard-font-light);
			cursor: pointer;
			display: flex;
			justify-content: space-between;
			align-items: center;
			min-height: 49px;
			.inst-text {
				font-size: 8px;
				line-height: 12px;
				display: block;
			}
			.name-text {
				font-size: 14px;
				line-height: 21px;
				color: var(--dashboard-font-dark);
			}
			&:not(.disabled) {
				&:active {
					filter: contrast(90%);
				}
				&:hover:not(:active) {
					filter: contrast(95%);
				}
			}
			&.disabled {
				cursor: not-allowed;
				opacity: 0.3;
			}
			.transtion-icon {
				transform: rotate(180deg) !important;
				transition: all 0.3s linear;
			}
		}
		.install-trigger {
			padding: 12px;
			text-align: center;
			min-height: 49px;
			width: 100%;
			max-width: 90px;
			background: var(--dashboard-success);
			color: var(--dashboard-font-dark);
			border-radius: 0px 0px 4px 0px;
			font-weight: 500;
			cursor: pointer;
			display: flex;
			align-items: center;
			justify-content: center;
			text-transform: uppercase;
			&:not(.disabled) {
				&:active {
					filter: contrast(90%);
				}
				&:hover:not(:active) {
					filter: contrast(95%);
				}
			}
			&.disabled {
				cursor: not-allowed;
				opacity: 0.3;
			}
		}
	}
}

.bundle-widget-project-list {
	border-radius: 4px;
	max-width: 450px;
	width: 100%;
	min-width: 450px;
	max-height: 300px;
	overflow-y: scroll;
	background-color: var(--dashboard-element-light);
	color: var(--dashboard-font-dark);
	div.flow-radio-wrapper > div.flow-radio {
		margin-right: 0px;
	}
}

.bundle-widget-install-wrapper {
	border-radius: 4px;

	background-color: var(--dashboard-element-light);
	color: var(--dashboard-font-dark);

	max-width: 450px;
	div.flow-tabs-container > div.flow-tabs-content-wrapper {
		overflow: visible;
	}
	.bundle-install-header {
		display: flex;
		padding: 16px;
		justify-content: space-between;
		align-items: center;
		.intall-wrap-title {
			font-weight: 400;
			font-size: 16px;
		}
	}
	.bundle-install-body {
		padding: 0px 16px;
		max-height: 400px;
		overflow-y: auto;

		.bundle-intall-content-wrap {
			padding: 16px 0px;
		}
	}
	.bundle-install-footer {
		padding: 12px;
		border-radius: 0px 0px 4px 4px;
		text-align: center;
		text-transform: uppercase;
		background: var(--dashboard-success);
		color: var(--dashboard-font-dark);
		font-size: 12px;
		font-weight: 500;
		cursor: pointer;
		&:active {
			filter: contrast(90%);
		}
		&:hover:not(:active) {
			filter: contrast(95%);
		}
	}
}
</style>
